import * as yup from 'yup'
import { AUTHORIZE_NOTES_MIN_LENGTH } from 'src/constants/payments-ops/constants'

export const authorizeTransactionValidator = yup.object({
  notes: yup
    .string()
    .test('min-trimmed-length', `At least ${AUTHORIZE_NOTES_MIN_LENGTH} characters`, (value) => {
      return (value ?? '').trim().length >= AUTHORIZE_NOTES_MIN_LENGTH
    }),
  isConfirmed: yup.boolean().test('ticked', 'Confirm the amount and destination', (value) => {
    return value === true
  }),
})
